import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20golden%20amber%20and%20cream%20tones%2C%20soft%20elegant%20texture%2C%20minimalist%20artistic%20style%2C%20no%20text%2C%20no%20people%2C%20editorial%20design%20aesthetic&width=1600&height=900&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-background-900/70"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备开始你的P站视频探索之旅？
        </h2>
        <p className="text-sm text-background-300 mb-8 leading-relaxed">
          从入门指南开始，逐步掌握搜索、下载、收藏等核心技能，成为P站视频使用达人
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/xinren-rumen"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            立即开始学习
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 rounded-full border border-background-300/60 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}